<template>
  <a :href="action">
    <div class="icon btn">
      <div class="tooltip" :class="dynamicStyle"> {{ tooltipText }}</div>
      <img :src="imageSource">
    </div>
  </a>
</template>

<script>
export default {
  props: ["tooltipText", "imageSource", "action", "tooltip_always_on"],
  computed: {
    dynamicStyle() {
      if(this.tooltip_always_on === "true") {
        return "tooltip_always_on"
      }
      return "";
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";

.icon {
  background: $color-white;
  border-radius: 50%;
  padding: 1.5rem;
  margin: 1rem;
  width: 5.5rem;
  height: 5.5rem;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(.22,.68,0,1.71);
}

.tooltip {
  position: absolute;
  top: 0;
  font-size: 1.4rem;
  background-color: #ffffff;
  color: #ffffff;
  padding: .5rem .8rem;
  border-radius: .5rem;
  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  pointer-events: none;
  transition: all 0.4s cubic-bezier(.22,.68,0,1.71);
  z-index: 1;
  border: solid 1px;
}

.tooltip_always_on {
  //tooltip always on
  top: -5.5rem !important;
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  z-index: 100;
  white-space: nowrap;
  background-color: $color-grey-light-2;
  color: $color-black;
  text-shadow: 0rem -.1rem 0rem rgba(0, 0, 0, 0.1);
  white-space: initial;
  width: 15rem;
}

.tooltip::before {
  position: absolute;
  content: "";
  height: .8rem;
  width: .8rem;
  background-color: $color-grey-light-2;
  bottom: -.5rem;
  left: 50%;
  transform: translate(-50%) rotate(45deg);
  transition: all 0.4s cubic-bezier(.22,.68,0,1.71);
  border-bottom: solid 1px;
  border-right: solid 1px;
}

.icon:hover .tooltip {
  top: -4.5rem;
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  z-index: 100;
  //white-space: initial;
  word-wrap: break-word;

}

.icon:hover span,
.icon:hover .tooltip {
  text-shadow: 0rem -.1rem 0rem rgba(0, 0, 0, 0.1);
}

.btn:hover,
.btn:hover .tooltip,
.btn:hover .tooltip::before {
  background-color: $color-grey-light-2;
  color: $color-black;
}
</style>
